import { Content } from "antd/es/layout/layout";
import { useContext, useState } from "react";
import {
  Breadcrumb,
  Button,
  DatePicker,
  Form,
  Input,
  Typography,
} from "antd";
import { useFetcher, useLoaderData, useNavigate } from "react-router-dom";
import { INTENTS } from "~/utils/constants";
import { BackgroundCheckPageLoaderType } from "./loaders";
import { userContext } from "~/context/ContextProvider";
import { HomeOutlined } from "@ant-design/icons";
import { BackgroundCheckFormValues } from "~/types";
import { useAppTranslation } from "~/hooks/useAppTranslation";

const { Title } = Typography;

export const BackgroundCheckPage = () => {
  const _loaderData = useLoaderData() as BackgroundCheckPageLoaderType;
  const { t } = useAppTranslation();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const fetcher = useFetcher();
  const {
    setIsDoneWithBackground,
  }: {
    setIsDoneWithBackground: React.Dispatch<React.SetStateAction<boolean>>;
  } = useContext(userContext);

  const handleSubmit = async (values: BackgroundCheckFormValues) => {
    setLoading(true);
    setIsDoneWithBackground(true);

    fetcher.submit(
      {
        intent: INTENTS._submit_background_check_info,
        body: JSON.stringify(values),
      },
      { method: "post" }
    );

    form.resetFields();
    setLoading(false);
  };

  const [form] = Form.useForm();

  return (
    <Content>
      <div className="signup-form">
        <Breadcrumb
          items={[
            {
              key: "home",
              title: (
                <HomeOutlined
                  onClick={() => {
                    navigate("/");
                  }}
                />
              ),
            },
            {
              key: "background",
              title: t("Background"),
            },
          ]}
          separator=">"
        />

        <Title className="signup-form-title" level={1}>
          {t("Background_Check_Info")}
        </Title>
        <Form form={form} onFinish={handleSubmit}>
          <Form.Item
            className="signup-form-item"
            label={t("First_Name")}
            name="firstName"
            rules={[
              {
                required: true,
                message: t("Enter_a_name"),
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            className="signup-form-item"
            label={t("Middle_Name")}
            name="middleName"
          >
            <Input />
          </Form.Item>
          <Form.Item
            className="signup-form-item"
            label={t("Last_Name")}
            name="lastName"
            rules={[
              {
                required: true,
                message: t("Enter_a_name"),
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            className="signup-form-item"
            label={t("Phone_Number")}
            name="phoneNumber"
          >
            <Input />
          </Form.Item>
          <Form.Item
            className="signup-form-item"
            label={t("Income")}
            name="income"
            rules={[
              {
                required: true,
                message: t("Enter_your_income"),
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            className="signup-form-item"
            label={t("Total_Credit")}
            name="totalCredit"
            // rules={[
            //   {
            //     required: true,
            //     message: "Please enter your total credit score",
            //   },
            // ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            className="signup-form-item"
            label={t("Employer")}
            name="employer"
          >
            <Input />
          </Form.Item>
          <Form.Item
            className="signup-form-item"
            label={t("Job_Title")}
            name="jobTitle"
          >
            <Input />
          </Form.Item>
          <Form.Item
            className="signup-form-item"
            label={t("Employer_Phone")}
            name="jobPhone"
          >
            <Input />
          </Form.Item>
          <Form.Item
            className="signup-form-item"
            label={t("Employer_Email")}
            name="jobEmail"
          >
            <Input />
          </Form.Item>
          <Form.Item
            className="signup-form-item"
            label={t("Employer_Contact_Name")}
            name="jobContactName"
          >
            <Input />
          </Form.Item>
          <Form.Item
            className="signup-form-item"
            label={t("Crimes_Committed")}
            name="cimesCommitted"
          >
            <Input />
          </Form.Item>
          <Form.Item
            className="signup-form-item"
            label={t("Jail_Time")}
            name="jailTime"
          >
            <Input />
          </Form.Item>
          <Form.Item
            className="signup-form-item"
            label={t("Last_Arrest")}
            name="lastArrest"
          >
            <DatePicker />
          </Form.Item>
          <Form.Item className="signup-form-submit-button">
            <Button type="primary" htmlType="submit" loading={loading} block>
              {t("Submit")}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </Content>
  );
};
